export enum PinType {
  PINNED = "PINNED",
  UNPINNED = "UNPINNED",
}
